module.exports = __webpack_public_path__ + "static/media/AWS-AI-Practitioner.a3211c1f.png";